import React, {useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider';
 
const P404 = () => {
 


  return (
    < > 

                    
<div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
               <div class="col-xl-7 example" 
                  style={{ 
                     background: 'url(https://gdsquantumsoft.com/bg.avif)',
                     backgroundSize: 'cover',
                     backgroundRepeat: 'no-repeat'
                     }} 
                  
                  >
                  <div class="auth-full-bg pt-lg-5 p-4" >
                        <div class="w-100">
                           <div class="bg-overlay" ></div>
                           <div class="d-flex h-100 flex-column">

                                 <div class="p-4 mt-auto">
                                    <div class="row justify-content-center">
                                       <div class="col-lg-7">
                                          <div class="text-center">
                                                
                                             
                                                <div dir="ltr">
                                                   <div >
                                                      <div class="item">
                                                            <div class="py-3">
                                                            
                                                               <div>
                                                                  
                                                               </div>
                                                            </div>
                                                            
                                                      </div>

                                                      <div class="item">
                                                            <div class="py-3">
                                                            
                                                               <div>
                                                                  
                                                               </div>
                                                            </div>
                                                            
                                                      </div>
                                                   </div>
                                                </div>
                                          </div>
                                       </div>
                                    </div>
                              </div> 
                           </div>
                        </div>
                  </div> 
               </div>  
               
               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                        <div class="w-100 p-5" >

                           <div class="text-center">
                              
                              
                                    <h2  ><b>404</b></h2>
                                 
                              

                           </div>
 
                        

                           

                           
                        </div>
                  </div>
               </div> 
            </div>
         </div>
        
        
  
        
 
        
  
      
    </>
  );
};

export default P404;

